angular.module('iw.frontyard.error', [

]);